import React from 'react';
import './index.pc.scss';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcStepProgressBar from 'components/molecules/PcStepProgressBar';
import PcPointComment from 'components/molecules/PcPointComment';
import PcInputTitle from 'components/molecules/PcInputTitle';
import DropdownInput from 'components/atoms/Input/DropdownInput';
import RequiredOrOptionalIcon from 'components/atoms/Icon/RequiredOrOptionalIcon';
import PcInputItem from 'components/molecules/PcInputItem';
import PcFreeInputArea from 'components/molecules/PcFreeInputArea';
import PcErrorArea from 'components/molecules/PcErrorArea';

import { POINT_COMMENT_MAP } from 'utils/constant';

// タイトル
const DispTitle = ({ title }) => {
  return Array.isArray(title) ? (
    title.map((line) => (
      <span key={line} className="">
        {line}
        <br />
      </span>
    ))
  ) : (
    <>{title}</>
  );
};

// 描画
const PresentPC = ({
  onClickMainButton,
  welfareDisp,
  workEnviDisp,
  ageRangeDisp,
  genderRangeDisp,
  workEnviCmntDisp,
  valid,
  errorDispMap,
}) => (
  <div className="">
    <div className="AddEnvi PC">
      <PcBasicTemplate
        path={window.location.pathname}
        onClickMainButton={onClickMainButton}
        valid={valid}
      >
        {/* プログレスバー  */}
        <PcStepProgressBar currentStep="6" />

        {/* 画面名 */}
        <div className="titleArea">
          <div className="title">職場環境</div>
        </div>

        {/* リック&スーの吹き出し 上 */}
        <PcPointComment labelList={POINT_COMMENT_MAP.enviPointCmnt1.labelList} pattern={POINT_COMMENT_MAP.enviPointCmnt1.pattern} />

        {/* 利用可能な福利厚生施設 チェックボックス */}
        <PcInputTitle
          title={welfareDisp.title}
          label={welfareDisp.label}
          list={welfareDisp.list}
          type={welfareDisp.type}
          /* 福利厚生施設 テキストエリア */
          comment={
            !welfareDisp.comment ? (
              <></>
            ) : (
              <>
                <PcFreeInputArea
                  visible={welfareDisp.comment.visible}
                  title={welfareDisp.comment.title}
                  label={welfareDisp.comment.label}
                  questionMark={welfareDisp.comment.questionMark}
                  popUpTitle={welfareDisp.comment.popUpTitle}
                  popUpDetail={welfareDisp.comment.popUpDetail}
                  relativePosArrow={welfareDisp.comment.relativePosArrow}
                  name={welfareDisp.comment.name}
                  textAreaValue={welfareDisp.comment.textAreaValue}
                  cmntOnChange={welfareDisp.comment.cmntOnChange}
                  onInput={welfareDisp.comment.onInput}
                  onCompositionEnd={welfareDisp.comment.onCompositionEnd}
                  maxLength={welfareDisp.comment.maxLength}
                  placeholder={welfareDisp.comment.placeholder}
                  rows={welfareDisp.comment.rows}
                  cols={welfareDisp.comment.cols}
                  wordCount={welfareDisp.comment.wordCount}
                  errMessage={welfareDisp.comment.errMessage}
                  inValid={welfareDisp.comment.inValid}
                />
              </>
            )
          }
        />

        {/* リック&スーの吹き出し 下 */}
        <PcPointComment labelList={POINT_COMMENT_MAP.enviPointCmnt2.labelList} pattern={POINT_COMMENT_MAP.enviPointCmnt2.pattern} />

        {/* 職場の特徴（複数選択可） */}
        <div className="mT30px">
          <PcInputTitle
            title={workEnviDisp.title}
            label={workEnviDisp.label}
            list={workEnviDisp.list}
            type={workEnviDisp.type}
          />
        </div>

        {/* 職場の年齢層 */}
        <div className="PcInputTitle mT30px">
          <div className="PITM-title">
            <DispTitle title="職場の年齢層" />
            <RequiredOrOptionalIcon label={ageRangeDisp.label} />
          </div>
        </div>

        <div className="AddEnvi_ageGroup">
          <span className="AddEnvi_ageGroup_DB">
            <DropdownInput
              items={ageRangeDisp.min.ageRangeList}
              selectedValue={ageRangeDisp.min.value}
              onChange={ageRangeDisp.min.onChange}
              isOpen={false}
              inValid={ageRangeDisp.min.inValid}
            />
          </span>
          <label>代</label>
          <label>～</label>
          <span className="AddEnvi_ageGroup_DB">
            <DropdownInput
              items={ageRangeDisp.max.ageRangeList}
              // selectedValue={_selectAgeGroupMax}
              selectedValue={ageRangeDisp.max.value}
              onChange={ageRangeDisp.max.onChange}
              isOpen={false}
              inValid={ageRangeDisp.max.inValid}
            />
          </span>
          <label>代</label>
        </div>
        <div className=''>
          <PcErrorArea position='' message={errorDispMap.ageRange} />
        </div>

        {/* 男女比率 */}
        <div className="PcInputTitle mT30px">
          <div className="width-50per">
            <PcInputItem
              title={genderRangeDisp.title}
              label={genderRangeDisp.label}
              questionMark={false}
            >
              {genderRangeDisp.list}
            </PcInputItem>
          </div>
        </div>

        {/* 上記以外の特徴 テキストエリア */}
        <div className="workEnviCmnt">
          <PcInputTitle
            title={workEnviCmntDisp.title}
            label={workEnviCmntDisp.label}
            list={workEnviCmntDisp.list}
            type={workEnviCmntDisp.type}
            errorDispMessages={workEnviCmntDisp.errorDispMessages}
          />
        </div>
      </PcBasicTemplate>
    </div>
  </div>
);

export default PresentPC;
